<template>
  <div class="pageContainer">
    <div class="container-1350 course-video">
      <div class="sidebar">
        <h2>{{ selected.name }}</h2>
        <!--        <p class="name">{{ selectedCourse.author.name }}</p>-->
        <!--        <p class="sub">{{ selectedCourse.author.designation }}</p>-->
        <ubtn
          class="get-certificate"
          v-if="!hasPaid"
          @click.prevent.native="Goto({ name: 'invoice' })"
          >Unlock All Videos</ubtn
        >
        <!--        >-->
        <ul>
          <li class="video-link" @click="$router.go(-1)">
            <i class="fa fa-arrow-left"></i> Go Back
          </li>
          <li
            class="video-link"
            :key="index"
            @click="selectVideo(item)"
            v-bind:class="{
              watched: item.watched,
              active: item.active
            }"
            v-for="(item, index) in selectedCourse"
          >
            <span class="lesson">Outline {{ index + 1 }}</span>
            <span class="title">{{ item.title }}</span>
          </li>
        </ul>
      </div>
      <div class="content">
        <div class="playing">
<!--          <youtube-->
<!--            id="upvid"-->
<!--            :video-id="selectedVideo.link"-->
<!--            :player-vars="playerVars"-->
<!--            fit-parent-->
<!--            ref="upskillplayer"-->
<!--            @ended="videoEnded"-->
<!--            v-if="selectedVideo.link"-->
<!--          ></youtube>-->
          <u-video :options="videoOptions" :key="selectedVideo" id="corsvid"></u-video>
          <div
            style="width: 100%;  display: flex; align-content: center; justify-content: center; flex-direction: column;"
            v-if="!selectedVideo.link"
          >
            <!--            <h3>{{ selectedCourse.description }}</h3>-->
            <!--            <h5 class="text-md-center" style="color: royalblue">-->
            <!--              (Please select a lesson from the sidebar)-->
            <!--            </h5>-->
          </div>
        </div>
        <p class="sub">{{ selectedCourse.categories }}</p>
        <div class="title-container">
          <div class="title">{{ selectedVideo.title }}</div>
          <div class="title" style="color: grey">{{ selectedVideo.description }}</div>
        </div>
        <div class="workshop_desc">
          <div class="cb-tab">
            <ul class="tab-header">
              <li class="active" data-target="#tab-one">Description</li>
              <li data-target="#tab-two">Course Outline</li>
            </ul>
            <div id="tab-one" class="tab-content active">
              <div v-html="RemoveStyle(ws.description)"></div>
            </div>
            <div id="tab-two" class="tab-content">
              <div v-html="RemoveStyle(ws.course_outline)"></div>
            </div>
          </div>
        </div>
        <div>
          <div v-html="selectedCourse.description"></div>
        </div>
        <div class="courses-carousel">
          <h3>
            <span>More popular Courses</span>
            <div class="carousel-nav">
              <a class="prev" href="#" data-target="#popular-courses:prev"></a>
              <a class="next" href="#" data-target="#popular-courses:next"></a>
            </div>
          </h3>
          <div id="popular-courses" class="cb-carousel">
            <div class="cb-carousel-item-container x4">
              <div
                class="item"
                v-for="course in popular"
                :key="course.id"
                @click="GotoBlogByID(course.id)"
              >
                <div class="course">
                  <div class="thumb">
                    <img :src="course.image" alt />
                  </div>
                  <h4>{{ course.name }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "@/modules/tab";
export default {
  data() {
    return {
      playerVars: {
        autoplay: 1,
        autohide: 1,
        showinfo: 0,
        modestbranding: 1,
        loop: 1,
        color: "#46C7C7",
        rel: 0
      },
      hasPaid: false,
      other: {},
      selectedCourse: { author: {} },
      selectedVideo: {},
      activeIndex: 0,
      interval: {},
      courses: [],
      allowCertificateGeneration: false,
      popular: [],
      selected: {},
      ws: {},
      videoOptions: {
        fluid: true,
        autoplay: true,
        controls: true,
        sources: [
          {
            src:
                    "",
            type: "video/mp4"
          }
        ]
      }
    };
  },
  methods: {
    videoEnded() {
      this.selectedVideo.watched = true;
      this.canGenerateCertificate();
      this.$mix.updateCourse(this.selectedCourse, this.courses, this.other);
      this.next();
    },
    canGenerateCertificate() {
      let noOfWatches = this.selectedCourse.videos
        .map(o => (o.watched ? 1 : 0))
        .reduce((x, y) => x + y);
      if (noOfWatches === this.selectedCourse.videos.length) {
        this.allowCertificateGeneration = true;
      }
    },
    selectVideo(item) {
      this.selectedCourse.forEach(c => {
        c.active = false;
      });
      item.active = true;
      this.selectedVideo = item;
      this.videoOptions = {
        fluid: true,
        autoplay: true,
        controls: true,
        sources: [
          {
            src:
                `https://cdn.upskill.com.bd/${item.link}.mp4`,
            type: "video/mp4"
          }
        ]
      }
    },
    next() {
      let indexOfSelectedVideo = this.selectedCourse.videos.indexOf(
        this.selectedVideo
      );
      if (indexOfSelectedVideo < this.selectedCourse.videos.length - 1) {
        this.selectVideo(this.selectedCourse.videos[indexOfSelectedVideo + 1]);
      } else {
        if (this.allowCertificateGeneration) {
          this.SuccessAlert("You have successfully completed this course! ");
        } else {
          this.selectVideo(this.selectedCourse.videos[0]);
        }
      }
    },
    sortVideos() {
      this.selectedCourse = this.selectedCourse.sort((a, b) => a.description - b.description)
    }
  },
  created() {
    let param = this.$route.params.id;
    this.$mix.getCourse(param).then(res => {
      // console.log(res)
      this.selectedCourse = res.course.data;
      this.hasPaid = res.course.access;
      this.popular = res.popular;
      this.selected = res.selected;
      this.sortVideos()
      this.selectVideo(this.selectedCourse[0])
      this.$upskill.workshop(this.selected.workshop_id).then(res => {
        this.ws = res.data.data
        this.Loaded();
      })
    });
  },
  mounted() {
    new Tab()
  }
};
</script>

<style scoped>
.video-link:hover {
  cursor: pointer;
  background-color: rgba(20, 255, 131, 0.25);
}
</style>
